/*
 * JavaScript Language Service for Monaco Editor (Code Workspace)
 * Provides full ES6+ TypeScript/JavaScript IDE experience.
 */

let isJsServiceConfigured = false;
let extraLibDisposable = null;

export function setupJavascriptLanguageService(monaco) {
  if (!monaco || isJsServiceConfigured) return;
  isJsServiceConfigured = true;

  try {
    const ts = monaco.languages.typescript;
    if (ts && ts.javascriptDefaults) {
      ts.javascriptDefaults.setDiagnosticsOptions({
        noSemanticValidation: false,
        noSyntaxValidation: false,
      });

      ts.javascriptDefaults.setCompilerOptions({
        target: ts.ScriptTarget.ES2022,
        allowNonTsExtensions: true,
        checkJs: false, // Don't show red squiggles for loose JS, but offer rich completions
        allowJs: true,
      });
    }
  } catch (e) {
    console.warn("Could not configure Monaco JavaScript defaults:", e);
  }
}

/**
 * Scan multi-file project files dynamically to register user-defined JS symbols
 */
export function updateJsProjectSymbols(monaco, projectFiles = []) {
  if (!monaco || !monaco.languages || !monaco.languages.typescript) return;

  try {
    if (extraLibDisposable) {
      extraLibDisposable.dispose();
      extraLibDisposable = null;
    }

    let extraDeclarations = "// Practido Multi-File Declarations\n";

    projectFiles.forEach((file) => {
      if (!file || !file.name || !file.name.endsWith(".js") || !file.content)
        return;
      const text = file.content;

      // Extract function declarations
      const funcRegex =
        /(?:^|\n)\s*(?:export\s+)?function\s+([a-zA-Z_$][a-zA-Z0-9_$]*)\s*\((.*?)\)/g;
      let m;
      while ((m = funcRegex.exec(text)) !== null) {
        extraDeclarations += `declare function ${m[1]}(${m[2]}): any;\n`;
      }

      // Extract class declarations
      const classRegex =
        /(?:^|\n)\s*(?:export\s+)?class\s+([a-zA-Z_$][a-zA-Z0-9_$]*)/g;
      while ((m = classRegex.exec(text)) !== null) {
        extraDeclarations += `declare class ${m[1]} { [key: string]: any; }\n`;
      }

      // Extract top-level const/let/var
      const varRegex =
        /(?:^|\n)\s*(?:export\s+)?(?:const|let|var)\s+([a-zA-Z_$][a-zA-Z0-9_$]*)\s*=/g;
      while ((m = varRegex.exec(text)) !== null) {
        extraDeclarations += `declare const ${m[1]}: any;\n`;
      }
    });

    if (extraDeclarations.length > 40) {
      extraLibDisposable =
        monaco.languages.typescript.javascriptDefaults.addExtraLib(
          extraDeclarations,
          "ts:practido-project-globals.d.ts",
        );
    }
  } catch (e) {
    console.warn("Error updating JS project symbols:", e);
  }
}
